import styled from 'styled-components';

import { breakpoints } from '@notino/react-styleguide';

export const MainImgWrapper = styled.div`
  order: 2;

  @media (min-width: ${breakpoints.lg}) {
    order: 1;
  }
`;

export const ImageWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const MainImgComponent = styled.img`
  width: 100%;

  @media (min-width: ${breakpoints.sm}) {
    max-width: 100%;
    max-height: 100%;

    flex-grow: 0;
    transition: opacity 0.5s;
  }
`;
